import { getSessionCountry } from "@faire/help-center-utils/serialized-data/getSessionCountry";
import { getDocumentOrThrow } from "@faire/web/common/globals/getDocument";
import { DEPRECATED_backwardsCompatibleValues, useStrictLocalization } from "@faire/web/common/localization";
import { getCountryDisplayNameFromSessionCountry } from "@faire/web/common/localization/getCountryDisplayNameFromSessionCountry";
import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
export var HelpCenterHelmet = function HelpCenterHelmet() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var country = getCountryDisplayNameFromSessionCountry(getSessionCountry(), strictLocalize);
  var title = country ? strictLocalize({
    id: "UZDHP+",
    defaultMessage: [{
      "type": 0,
      "value": "Faire "
    }, {
      "type": 1,
      "value": "country"
    }, {
      "type": 0,
      "value": " – Centre d'aide"
    }]
  }, DEPRECATED_backwardsCompatibleValues({
    country: country
  })) : strictLocalize({
    id: "21+QMV",
    defaultMessage: [{
      "type": 0,
      "value": "Faire – Centre d'aide"
    }]
  });
  return /*#__PURE__*/React.createElement(FaireHelmet, {
    title: title
  });
};
var FaireHelmet = function FaireHelmet(_ref) {
  var title = _ref.title;
  var oldTitle = useRef("");
  useEffect(function () {
    oldTitle.current = getDocumentOrThrow().title;
    return function () {
      getDocumentOrThrow().title = oldTitle.current;
    };
  }, [oldTitle]);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, title));
};